import template from 'header/cart-confirm.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-cart-confirm',
        watch: 'core.cart',
        name: 'cartComponent',
        template: template,
        renderType: dDom
    };

    return generate(config, store, overrides);
}

